// Publications come from seed repos and are only validated at publish time, so
// every read below treats them as untrusted: a missing or mistyped field renders
// as empty, never as a crash of the whole page.

/** `value` when it is an array, else an empty one. */
export const arr = <T = unknown>(value: unknown): T[] => Array.isArray(value) ? value as T[] : []
/** `value` when it is a string, else `''`. */
export const text = (value: unknown) => typeof value === 'string' ? value : ''
/** The entry for `locale`, else `en`, else the first one — objects only. */
export function pick<T extends object>(record: unknown, locale: string): T | undefined {
  if (!record || typeof record !== 'object') return undefined
  const values = record as Record<string, unknown>
  const found = [values[locale], values.en, ...Object.values(values)].find(value => !!value && typeof value === 'object' && !Array.isArray(value))
  return found as T | undefined
}

/** The first non-empty string among `value[locale]`, `value.en` and the other values. */
export function local(value: unknown, locale: string): string {
  if (typeof value === 'string') return value
  if (!value || typeof value !== 'object') return ''
  const values = value as Record<string, unknown>
  const found = [values[locale], values.en, ...Object.values(values)].find(candidate => typeof candidate === 'string' && candidate !== '')
  return (found as string | undefined) || ''
}
export const duration = (seconds?: unknown, fallback?: unknown) => text(fallback) || (typeof seconds === 'number' && Number.isFinite(seconds) ? `${Math.floor(seconds / 60)}:${String(Math.round(seconds % 60)).padStart(2, '0')}` : '')
export const surfaces = (values: unknown, locale: string) => arr(values).filter((value): value is string => typeof value === 'string').map(value => ({
  agent: locale === 'fr' ? 'Application agent · téléphone' : 'Field agent app · phone',
  'portal-coop': locale === 'fr' ? 'Portail coopérative' : 'Cooperative portal',
  'portal-trader': locale === 'fr' ? 'Portail négociant' : 'Trader portal',
}[value] || value)).join(' → ')

export function timestamp(seconds: number) {
  const value = Math.max(0, Math.floor(seconds))
  return `${Math.floor(value / 60)}:${String(value % 60).padStart(2, '0')}`
}
